<template>
    <div class="container" @click="scrollToTop">
        <img src="@/assets/themeFour/f5.png" alt="">
    </div>
</template>

<script setup lang="ts">
const scrollToTop = () => {
    document.getElementById('top-of-home-page')?.scrollIntoView({ behavior: 'smooth' });
};

</script>
<style scoped>
.container {
    position: fixed;
    bottom: 90px;
    right: 15px;
    z-index: 1000; 
    cursor: pointer; 
}

.container img {
    border-radius: 10px;
    width: 55px;
    transition: transform 0.2s;
}

.container img:active {
    transform: scale(0.9);
}
</style>